import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { BrandLogo } from "../components/BrandLogo";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

const Campo = ({ id, label, value, onChange }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id}>{label}</Label>
    <Input id={id} type="password" autoComplete="new-password" value={value} onChange={(e) => onChange(e.target.value)} data-testid={`reinicio-${id}`} />
  </div>
);

const Formulario = ({ onDone }) => {
  const [f, setF] = useState({ codigo: "", password: "", repetir: "" });
  const [busy, setBusy] = useState(false);
  const enviar = async (e) => {
    e.preventDefault();
    if (f.password !== f.repetir) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    setBusy(true);
    try {
      await api.post("/public/reinicio-superadmin", { codigo: f.codigo, password: f.password });
      onDone();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={enviar} className="space-y-4" data-testid="reinicio-form">
      <Campo id="codigo" label="Código de reinicio" value={f.codigo} onChange={(v) => setF({ ...f, codigo: v })} />
      <Campo id="password" label="Contraseña nueva" value={f.password} onChange={(v) => setF({ ...f, password: v })} />
      <Campo id="repetir" label="Repite la contraseña nueva" value={f.repetir} onChange={(v) => setF({ ...f, repetir: v })} />
      <Button type="submit" disabled={busy} className="w-full bg-slate-900 hover:bg-slate-800" data-testid="reinicio-submit">
        {busy ? "Guardando…" : "Restablecer superadmin"}
      </Button>
    </form>
  );
};

export default function ReinicioSuperadmin() {
  const [estado, setEstado] = useState(null);
  useEffect(() => {
    api.get("/public/reinicio-superadmin").then(({ data }) => setEstado(data.habilitado ? "form" : "off")).catch(() => setEstado("off"));
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md bg-white border rounded-xl p-8 space-y-6" data-testid="reinicio-page">
        <BrandLogo />
        <h1 className="font-heading text-2xl font-bold">Restablecer superadmin</h1>
        {estado === "off" && <p className="text-sm text-slate-600" data-testid="reinicio-off">El reinicio no está habilitado.</p>}
        {estado === "form" && <Formulario onDone={() => setEstado("ok")} />}
        {estado === "ok" && (
          <div className="space-y-3 text-sm" data-testid="reinicio-ok">
            <p>Listo. Ingresa con tu contraseña nueva y vuelve a activar el autenticador. Este mecanismo quedó desactivado.</p>
            <Link to="/ingresar" className="underline text-blue-700">Ir a ingresar</Link>
          </div>
        )}
      </div>
    </div>
  );
}
